module.exports = __webpack_public_path__ + "img/hand-mobile.b5fd5d27.png";